import axios from 'axios';
import { API_URL } from '../config';

const newInstance = axios.create();

export const fetchTransport = () => {
  const URL = `${API_URL}/transport-type`;
  return newInstance
    .get(URL)
    .then((response) => response.data.transport_types[0]);
};

export const fetchPrice = (params) => {
  const {
    mtplAmount,
    dvpaAmount,
    cascoAmount,
    insuredSeats,
    seatsCount,
    vehicleData,
  } = params;

  const body = {
    vehicles: [
      {
        type: {
          id: vehicleData.transport && vehicleData.transport.id,
          label: vehicleData.transport && vehicleData.transport.label,
        },
        purpose: {
          id: vehicleData.purpose && vehicleData.purpose.id,
          label: vehicleData.purpose && vehicleData.purpose.label,
        },
        seatsCount,
        insuredSeats,
        mtplInsuranceAmount: mtplAmount,
        dvpaInsuranceAmount: dvpaAmount,
        cascoInsuranceAmount: cascoAmount,
      },
    ],
  };

  const URL = `${API_URL}/price/appka`;
  return newInstance.post(URL, body).then((response) => response.data);
};
